// extracted by mini-css-extract-plugin
export default {"container":"CrmBoard_container__ui2oF","leftSection":"CrmBoard_leftSection__RY0b9","rightSection":"CrmBoard_rightSection__DSYyO"};